/**
 * Маршрут для хеш-адреси прототипу v4 на будь-якій сторінці застосунку: #observe… — вибір особи спостерігача, #register — реєстрація,
 * #login — вхід; інший хеш — null (лишається як є). Чиста функція.
 */
export function entryHashTarget(hash: string): string | null {
  if (/^#observe/.test(hash)) return '/observe';
  if (hash === '#register') return '/register';
  if (hash === '#login') return '/login';
  return null;
}
